var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ux-app-freezer"}},[_c('div',{staticClass:"nuxt-loading"},[_c('div')])])}]

export { render, staticRenderFns }